export const initContactForm = () => {
  const contactForm = document.querySelector(".js-contact-form");

  if (!contactForm) return;

  const completeUrl = contactForm.dataset.completeUrl;

  contactForm.addEventListener("wpcf7mailsent", () => {
    if (completeUrl) {
      window.location.assign(completeUrl);
    }
  });

  contactForm.addEventListener("wpcf7invalid", () => {
    window.requestAnimationFrame(() => {
      const firstInvalidField = contactForm.querySelector(".wpcf7-not-valid");

      if (firstInvalidField instanceof HTMLElement) {
        firstInvalidField.focus();
      }
    });
  });
};
